import * as v from "valibot";

const configSchema = v.objectWithRest(
  {
    art: v.pipe(
      v.string(),
      v.minLength(1),
      v.transform(value => parseInt(value, 10))
    ),
    user: v.pipe(
      v.string(),
      v.minLength(1),
      v.transform(value => parseInt(value, 10))
    ),
    baseurl: v.string(),
    trials: v.optional(
      v.pipe(
        v.picklist(["0", "1"]),
        v.transform(value => parseInt(value, 10)),
        v.picklist([0, 1])
      )
    ),
    texttrialbutton: v.optional(v.string()),
    uilang: v.optional(v.pipe(v.string(), v.minLength(1)), "ru"),
    price: v.optional(v.string()),
    iframe: v.pipe(
      v.optional(v.string()),
      v.transform(value => Boolean(value))
    ),
    chapter: v.optional(
      v.pipe(
        v.string(),
        v.transform(value => parseInt(value, 10))
      )
    ),
    draftFree: v.pipe(
      v.optional(v.string()),
      v.transform(value => Boolean(value))
    ),
    showSaleBlock: v.pipe(
      v.optional(v.string()),
      v.transform(value => value === "1")
    ),
    isAvailableBySubscription: v.pipe(
      v.optional(v.string()),
      v.transform(value => value === "1")
    ),
    notification: v.optional(v.string()),
    notificationType: v.pipe(
      v.optional(v.picklist(["info", "warning", "error"]), "info"),
      v.transform(value => value as "info" | "warning" | "error")
    ),
  },
  v.unknown()
);

function snakeToCamelKeys(obj: Record<string, string>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key.replace(/_([a-z])/g, (_, char) => char.toUpperCase()),
      value,
    ])
  );
}

export function getConfig() {
  const params = new URLSearchParams(window.location.search);
  const rawConfig = snakeToCamelKeys(Object.fromEntries(params.entries()));
  const result = v.parse(configSchema, rawConfig);
  const { baseurl: contentUrl } = result;
  const fileId = contentUrl.split("/").at(-2);

  return {
    ...result,
    fileId: parseInt(fileId, 10),
    contentUrl,
  };
}

export type Config = ReturnType<typeof getConfig>;
